const state = {
    grade: null,
    gender: null,
    year: null,
    last_name: null,
    first_name: null,
    middle_name: null,
    alt_last_name: null,
    nickname: null,
    street_address: null,
    city: null,
    state: null,
    zipcode: null,
    mailing_street_address: null,
    mailing_city: null,
    mailing_state: null,
    mailing_zipcode: null,
    phone: null,
    phone_type: null,
    phone_only_emergencies: false,
    birthdate: null,
    birthplace: null,
    custody_issues: null,
    latino: null,
    american_indian: false,
    pacific_islander: false,
    black: false,
    asian: false,
    white: false,
    home_language: null,
    student_language: null,
    student_first_language: null,
    preferred_language: null,
    selected_race: [],
}

const mutations = {
    setGrade(state, value) { state.grade = value },
    setGender(state, value) { state.gender = value },
    setYear(state, value) { state.year = value },
    setLastName(state, value) { state.last_name = value },
    setFirstName(state, value) { state.first_name = value },
    setMiddleName(state, value) { state.middle_name = value },
    setAltLastName(state, value) { state.alt_last_name = value },
    setNickname(state, value) { state.nickname = value },
    setStreetAddress(state, value) { state.street_address = value },
    setCity(state, value) { state.city = value },
    setState(state, value) { state.state = value },
    setZipcode(state, value) { state.zipcode = value },
    setMailingStreetAddress(state, value) { state.mailing_street_address = value },
    setMailingCity(state, value) { state.mailing_city = value },
    setMailingState(state, value) { state.mailing_state = value },
    setMailingZipcode(state, value) { state.mailing_zipcode = value },
    setPhone(state, value) { state.phone = value },
    setPhoneType(state, value) { state.phone_type = value },
    setPhoneUseCase(state, value) { state.phone_only_emergencies = value },
    setBirthdate(state, value) { state.birthdate = value },
    setBirthplace(state, value) { state.birthplace = value },
    setCustodyIssues(state, value) { state.custody_issues = value },
    setIsLatino(state, value) { state.latino = value },
    setIsAmericanIndian(state, value) { state.american_indian = value },
    setIsPacificIslander(state, value) { state.pacific_islander = value },
    setIsBlack(state, value) { state.black = value },
    setIsWhite(state, value) { state.white = value },
    setIsAsian(state, value) { state.asian = value },
    setHomeLanguage(state, value) { state.home_language = value },
    setStudentLanguage(state, value) { state.student_language = value },
    setStudentFirstLanguage(state, value) { state.student_first_language = value },
    setPreferredLanguage(state, value) { state.preferred_language = value },
    setSelectedRace(state, value) { state.selected_race = value },
}

export default {
    namespaced: true,
    state,
    mutations
}


